export default {
    active_sessions: "Aktiv seanslar",
    ask_for_details_on_response: "Cavab verərkən təfərrüatları soruşun",
    browser: "Browser",
    browser_data: "Browser məlumatı",
    current_session: "Hazırki seans",
    delete_all_sessions_except_current: "Hazırki seansı istisna olmaqla bütün seansları sil",
    delete_attachment: "Əlavəni sil",
    delete_signed: "İmzalanmışı sil",
    failed_login_attempts: "Uğursuz giriş cəhdləri",
    finished_sessions: "Bitmiş seanslar",
    last_use: "Son istifadə",
    login_attempt: "Giriş cəhdi",
    operating_system: "İşletim sistemi",
    password_expires_in_days: "Şifrənizin müddəti bu gün bitir | Şifrənizin müddəti {day} gün sonra bitir | Şifrənizin müddəti {day} gün ərzində bitir",
    password_valid_until_note: "Cari şifrənin etibarlılıq müddəti:",
    question_for_women_only: "Yalnız qadınlar üçün sual",
    reset_questionnaire_fill: "Sorğu doldurmasını sıfırla",
    sessions: "Seanslar",
    tell_more: "Daha çox məlumat verin",
    wrong_password: "Yanlış parol",
    "2fa_failed": "İkifaktorlu autentifikasiya xətası"
}
